<style scoped>

</style>
<template>
  <div>
    <div
      v-if="fi_wage_topic.id"
      class="line text-large text-bold"
    >
      <span>{{ fi_wage_topic.wage_month }} </span>
      <span>{{ fi_wage_topic.name }}</span>
      <Button
        v-if="canEdit"
        type="warning"
        :loading="saving"
        @click="saveRecords"
      >
        保存
      </Button>
    </div>
    <table class="mis-table">
      <tr>
        <th>姓名</th>
        <th>银行信息</th>
        <th>公司-团队</th>
        <th>工资金额</th>
        <th>操作</th>
      </tr>
      <tr
        v-for="(record, index) in records"
        :key="record.id"
      >
        <td>{{ record.customer.account }}</td>
        <td>
          <div>银行: {{ record.cur_bank }}</div>
          <div>卡号: {{ record.cur_bank_number }}</div>
        </td>
        <td>
          <div>{{ getCompanyName(record.company_id) }}</div>
          <div>{{ getTeamName(record.team_id) }}</div>
        </td>
        <td>
          <div v-if="canEdit">
            ￥<i-input
              v-model="record.total_wage"
              size="small"
              :style="{width: '120px'}"
            />
          </div>
          <div v-else>
            ￥{{ formatPrice(record.total_wage) }}
          </div>
        </td>
        <td>
          <Button
            v-if="canEdit"
            size="small"
            @click="delRecord(record, index)"
          >
            删除
          </Button>
          <span v-else>-</span>
        </td>
      </tr>
    </table>
    <div class="text-large text-bold line">
      正式实习生列表
    </div>
    <table class="mis-table">
      <tr>
        <th>姓名</th>
        <th>银行信息</th>
        <th>公司-团队</th>
        <th>操作</th>
      </tr>
      <tr
        v-for="customer in customers"
        :key="customer.id"
      >
        <td>{{ customer.account }}</td>
        <td>
          <div>银行: {{ customer.bank }}</div>
          <div>卡号: {{ customer.bank_number }}</div>
        </td>
        <td>
          <div>{{ getCompanyName(customer.company_id) }}</div>
          <div>{{ getTeamName(customer.team_id) }}</div>
        </td>
        <td>
          <Button
            v-if="canAdd(customer)"
            size="small"
            @click="addRecord(customer)"
          >
            添加
          </Button>
          <span v-else>-</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script :route="{path: '/hr/fi_wage_records/:topic_id',noChkout: true}">
  import Util from '../../libs/util';
  import FlowUtil from '../../libs/flow_util';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info:{
      path: '/hr/fi_wage_records/:topic_id',
      noChkout: true
    },
    /* router_info_end */

    data() {
      return {
        params: {
          topic_id: this.$route.params.topic_id
        },
        fi_wage_topic: {},
        records: [],
        customers: [],
        adding_record: false,
        deling_record: false,
        saving: false
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
      canEdit() {
        return FlowUtil.canEdit(this.fi_wage_topic, this.cur_customer);
      }
    },
    created() {
      this.getTopicRecords();
      this.getFormalInterns();
    },
    mounted() {
      //
    },
    methods: {
      getTopicRecords() {
        Util.ajax.get(Util.api.get_fi_wage_records, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.records = [];
          if (data.code === 1) {
            this.fi_wage_topic = data.topic;
            data.records.forEach((record) => {
              this.records.push(record);
            });
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({
            title: '提示',
            content: `获取数据失败: ${e.message}`
          });
        });
      },
      getFormalInterns() {
        Util.ajax.get(Util.api.get_formal_interns, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.customers = [];
          if (data.code === 1) {
            data.customers.forEach((customer) => {
              this.customers.push(customer);
            });
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({
            title: '提示',
            content: `获取数据失败: ${e.message}`
          });
        });
      },
      addRecord(customer) {
        if (!customer.bank_number) {
          this.$Message.error('没有银行卡信息, 不能添加');
          return;
        }
        if (this.adding_record) {
          return;
        }
        this.adding_record = true;
        Util.ajax.post(Util.api.add_fi_wage_record, {
          topic_id: this.fi_wage_topic.id,
          customer_id: customer.id
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.adding_record = false;
          if (data.code === 1) {
            Util.insertOrUpdateArrayItem(this.records, data.record, true);
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.adding_record = false;
          this.$Modal.error({
            title: '提示',
            content: `操作失败: ${e.message}`
          });
        });
      },
      delRecord(record, index) {
        if (this.deling_record) {
          return;
        }
        this.deling_record = true;
        Util.ajax.post(Util.api.del_fi_wage_record, {
          topic_id: this.fi_wage_topic.id,
          id: record.id
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.deling_record = false;
          if (data.code === 1) {
            this.records.splice(index, 1);
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.deling_record = false;
          this.$Modal.error({
            title: '提示',
            content: `操作失败: ${e.message}`
          });
        });
      },
      checkValid() {
        let msg = '';
        this.records.forEach((record, index) => {
          if (!record.total_wage) {
            msg += `<p>${record.customer.account} 未填写工资</p>`;
          } else {
            if (!Util.isNumber(record.total_wage)) {
              msg += `<p>${record.customer.account} 请填写正确的工资金额</p>`;
            } else if (math.eval(`${record.total_wage} <= 0`)) {
              msg += `<p>${record.customer.account} 工资金额不能小于0</p>`;
            }
          }
        });
        if (msg) {
          this.$Modal.error({title: '错误', content: msg});
          return false;
        }
        return true;
      },
      saveRecords() {
        if (this.saving || !this.checkValid()) {
          return;
        }
        this.saving = true;
        Util.ajax.post(Util.api.save_fi_wage_records, {
          topic_id: this.fi_wage_topic.id,
          records: this.records
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.saving = false;
          if (data.code === 1) {
            this.$Message.success('保存成功!');
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.saving = false;
          this.$Modal.error({
            title: '提示',
            content: `获取数据失败: ${e.message}`
          });
        });
      },
      canAdd(customer) {
        const len = this.records.length;
        let val = true;
        for (let i = 0; i < len; i++) {
          const record = this.records[i];
          if (record.customer_id === customer.id) {
            val = false;
            break;
          }
        }
        return val;
      },
      getCompanyName(id) {
        const company = this.companies_hash[id];
        return company ? company.name : '-';
      },
      getTeamName(id) {
        const team = this.teams_hash[id];
        return team ? team.name : '-';
      },
      formatPrice(price) {
        return Util.formatPrice(price);
      }
    }
  }
</script>
